import React from 'react'

import { Field } from 'formik'

import { Form, Col, Row } from '_zari/core'

const FlagTransbordoFormGroup = ({ fIsSubmitting, iValue }) => {
  return (
    <Row>
      <Col md={12} className='pt-2'>
        <Field name='flagTransbordo'>
          {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagTransbordo' label='Transbordo' />}
        </Field>
      </Col>
    </Row>
  )
}

export default React.memo(FlagTransbordoFormGroup)
